import * as Yup from 'yup';

export const loginValidation = Yup.object().shape({
  email: Yup.string().when('$reauth', {
    is: false,
    then: Yup.string().required('Ce champ est requis').email("Format de l'email incorrect.").default('')
  }),
  password: Yup.string().required('Ce champ est requis').default(''),
});
